import { useAppContext } from 'hooks/context/useAppContext';

export const useCancellation = () => {
  const {
    publicUser: {
      preferences: {
        cancellation_fee: cancellationPolicyFee,
        cancellation_policy: cancellationPolicyText,
        cancellation_window: cancellationPolicyTimeWindow,
        cancellation_policy_force_accept: cancellationPolicyForceAccept,
        waitlist_cancellation_policy_force_accept:
          waitlistCancellationPolicyForceAccept,
      },
    },
  } = useAppContext();

  return {
    hasCancellationPolicy: cancellationPolicyText?.length > 0,
    cancellationPolicyFee,
    cancellationPolicyText,
    cancellationPolicyTimeWindow,
    cancellationPolicyForceAccept,
    waitlistCancellationPolicyForceAccept,
  };
};
